import { ModelPricingLookupResult, ModelPricingRate, ModelPricingRecord } from '@/types/modelPricing'

export function normalizeModelPricingLookupModel(model: string): string {
  const trimmed = model.trim()
  if (trimmed.startsWith('models/')) {
    return trimmed.slice('models/'.length)
  }
  return trimmed
}

export function modelPricingCacheKey(providerKey: string, model: string): string {
  return `${providerKey}::${normalizeModelPricingLookupModel(model)}`
}

export function getModelPricingRecord(result?: ModelPricingLookupResult | null): ModelPricingRecord | null {
  if (!result || !result.found) return null
  const record = result.record
  if (!record || typeof record !== 'object' || !('rates' in record)) return null
  return record as ModelPricingRecord
}

function firstRate(
  record: ModelPricingRecord,
  component: ModelPricingRate['component'],
  preferredTier: ModelPricingRate['tier'] = 'standard'
): ModelPricingRate | null {
  return (
    record.rates.find((rate) => rate.component === component && rate.tier === preferredTier) ||
    record.rates.find((rate) => rate.component === component) ||
    null
  )
}

export function getModelPricingDisplayRates(record: ModelPricingRecord | null): {
  input: ModelPricingRate | null
  output: ModelPricingRate | null
} {
  if (!record) {
    return { input: null, output: null }
  }

  return {
    input: firstRate(record, 'input'),
    output: firstRate(record, 'output')
  }
}

export function formatModelPricingAmount(rate: ModelPricingRate | null): string {
  if (!rate) return 'Pricing unavailable'
  const suffix = rate.unit === 'usd_per_1m_tokens_per_hour' ? '/1M/hr' : '/1M'
  return `$${rate.amountUsd.toLocaleString(undefined, { maximumFractionDigits: 4 })} ${suffix}`
}
